import { PlaceholderPage } from './PlaceholderPage';

export const TerminationDetailsPage = () => <PlaceholderPage title="Termination Details" subtitle="Read-only panel" />;
